import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var Refresh = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Refresh_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 .501a.501.501 0 1 0-1.002 0v3.003l-.062-.083C13.447 1.37 10.99.033 8.216.033 3.693.033 0 3.593 0 8.017 0 12.44 3.693 16 8.216 16c3.185 0 5.952-1.761 7.316-4.346a.501.501 0 0 0-.886-.467c-1.192 2.258-3.62 3.81-6.43 3.81-3.999 0-7.214-3.14-7.214-6.98 0-3.842 3.215-6.982 7.214-6.982 2.449 0 4.607 1.18 5.91 2.978l.372.496H10.99a.501.501 0 1 0 0 1.002h4.509a.501.501 0 0 0 .501-.5V.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Refresh_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default Refresh;